export const sessionStorageKeys = {
    whitelistClientData: 'whitelist-app-links',
};